'use strict';

module.exports = function(colorA, colorB) {
	var i;
	var colorDiff = [];

	for (i = 0; i < 3; i++) {
		colorDiff.push(colorB[i] - colorA[i])
	}

	return colorDiff;
};



//////////////////
// WEBPACK FOOTER
// ./~/granim/lib/colorDiff.js
// module id = 13
// module chunks = 0